module.exports = __webpack_public_path__ + "static/media/White Font Tec Mow.ec4dd1ee.svg";